import { useResolvedVoucherDiscount } from '../VoucherDiscount/useResolvedVoucherDiscount';
import { isConditionalDiscount } from '../VoucherDiscount/utils';

type Return = 'noVoucherDiscount' | 'priceBelowMinCondition' | 'default';

export const usePriceLabelState = (): Return => {
  const voucherDiscount = useResolvedVoucherDiscount();

  if (!voucherDiscount) {
    return 'noVoucherDiscount';
  }

  const isPriceBelowMinCondition =
    isConditionalDiscount(voucherDiscount) &&
    voucherDiscount.discountConditions.some(
      ({ productMetCondition }) => !productMetCondition
    );

  if (isPriceBelowMinCondition && voucherDiscount.conditionType === 'Price') {
    return 'priceBelowMinCondition';
  }

  return 'default';
};
